import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Conseil } from "../../models/conseil";
import { ConseilService } from "../../services/conseil.service";
import { Observable } from "rxjs";

@Component({
    selector: 'app-conseils',
    templateUrl: './conseils.component.html',
    styleUrls: ['./conseils.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConseilsComponent implements OnInit {

  conseils$: Observable<Conseil[]>;

  constructor(private conseilService: ConseilService) {
  }

  ngOnInit() {
    this.conseils$ = this.conseilService.load();
  }

}
